// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"29591505","88":"5e6694a2","296":"5e6694a2","487":"1c0d4685","557":"9014d564","695":"29591505","770":"c3fdac37","883":"29591505","920":"460a6187"}[chunkId] + ".chunk.css";
};